import { Component, OnInit, ViewChild, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { SessionService } from 'src/app/services/session.service';
import { GridSpinnerComponent } from 'src/app/shared/grid-spinner.component';
import { MediaMatcher } from '@angular/cdk/layout';

@Component({
  selector: 'app-unavailable-dashboard',
  templateUrl: './unavailable-dashboard.component.html',
  styleUrls: []
})
export class UnavailableDashboardComponent implements OnInit {
  constructor() {}
  ngOnInit() { }
}
